import IconLabelledItem from '../IconLabelledItem/IconLabelledItem';

const TriggerTemplateParams = () => {
  return (
    <div className='flex w-4/5 flex-1 gap-6'>
      <IconLabelledItem iconName='cb-filters-vehicle-group-cb' label='Todos os grupos' />
      <IconLabelledItem iconName='car-front' label='Todos os veículos' />
      <IconLabelledItem iconName='calendar-range' label='Todos os dias e horários' />
    </div>
  );
};

export default TriggerTemplateParams;
